import { render, staticRenderFns } from "./NewMediafile.vue?vue&type=template&id=72079b3a&scoped=true&"
import script from "./NewMediafile.vue?vue&type=script&lang=js&"
export * from "./NewMediafile.vue?vue&type=script&lang=js&"
import style0 from "./NewMediafile.vue?vue&type=style&index=0&id=72079b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72079b3a",
  null
  
)

export default component.exports